import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import editIcon from '../../../assets/img/icons/edit-pen.svg';
import TableCustomCheckboxDropdown from '../../../components/CustomCheckboxDropdown/TableCustomCheckboxDropdown';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../../components/NoDataComponent/NoDataComponent';
import TaskActionTooltip from '../../../components/Tooltip/TaskActionTooltip';
import { TableItem } from '../../../styledComponents/ProjectsNew';
import {
  CommonImage,
  Container,
  TableText,
} from '../../../styledComponents/common';
import {
  EditButton,
  ListBody,
  ListContainer,
  ListItem,
  MasterTaskTable,
  SubTaskItem,
  SubTaskList,
} from '../../../styledComponents/tasks';
import { RoundIcon } from '../tasksStyles';

const MasterTasksList = ({
  masterTasksList,
  editMasterTask,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const [openedOfficeDropdown, setOpenedOfficeDropdown] = useState(null);

  const handleOfficeDropdownClick = id => {
    if (openedOfficeDropdown === id) {
      setOpenedOfficeDropdown(null);
    } else {
      setOpenedOfficeDropdown(id);
    }
  };

  const handleEdit = task => {
    const updatedTask = { ...task, name: task.name };
    editMasterTask({ task_id: task.id, ...updatedTask });
  };

  return (
    <Container style={{ paddingBottom: '20px' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : masterTasksList && masterTasksList.length > 0 ? (
        <>
          <MasterTaskTable heading>
            <TableItem>
              <TableText>{t('task_code')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('related_offices')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('default_task_duration')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('max_task_duration')}</TableText>
            </TableItem>
            <TableItem>
              <TableText />
            </TableItem>
          </MasterTaskTable>
          {masterTasksList?.map((task, i) => (
            <MasterTaskTable key={task.id}>
              <TableItem>
                <TableText>{task.code}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{task.name}</TableText>
              </TableItem>
              <TableItem>
                {task.related_office && task.related_office.length > 0 ? (
                  <div style={{ maxWidth: '250px', width: '100%' }}>
                    <TableCustomCheckboxDropdown
                      opened={openedOfficeDropdown === task.id}
                      options={task.related_office.map(office => ({
                        label: office.name,
                        value: office.id,
                      }))}
                      selectedOptions={task.related_office.map(office => ({
                        label: office.name,
                        value: office.id,
                      }))}
                      onClick={() => handleOfficeDropdownClick(task.id)}
                      onChange={() => {}} // Read-only, no changes needed
                      placeholder="related_offices"
                      countLabel="offices_selected"
                      styles={{
                        button: {
                          cursor: 'default',
                        },
                        menu: {
                          zIndex: 100,
                        },
                      }}
                    />
                  </div>
                ) : (
                  <TableText>{t('no_offices')}</TableText>
                )}
              </TableItem>
              <TableItem>
                <TableText>
                  {task.default_task_duration
                    ? `${task.default_task_duration} h`
                    : `${t('not_set')}`}
                </TableText>
              </TableItem>
              <TableItem>
                <TableText>
                  {task.max_task_duration
                    ? `${task.max_task_duration} h`
                    : `${t('not_set')}`}
                </TableText>
              </TableItem>
              <TableItem>
                <RoundIcon
                  height="24px"
                  width="24px"
                  type="edit"
                  onClick={() => handleEdit(task)}
                >
                  <CommonImage src={editIcon} alt="" size="14px" />
                  <TaskActionTooltip toolTipText={t('edit_task')} />
                </RoundIcon>
              </TableItem>
            </MasterTaskTable>
          ))}
        </>
      ) : (
        <NoDataComponent
          title={t('no_master_tasks_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default MasterTasksList;
